import RestAPI from 'src/common/RestApi'

export function getBookingWindowsForDateApi(dateData) {
  return RestAPI.getWithFormData('/website_builder/schedule_availability', dateData);
};
